import { render, staticRenderFns } from "./VisitGuarantorDetail.vue?vue&type=template&id=9bc2d23c"
import script from "./VisitGuarantorDetail.vue?vue&type=script&lang=js"
export * from "./VisitGuarantorDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports